export function cloneDate(date) {
  return new Date(+date);
}
